var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{attrs:{"value":_vm.value,"rules":_vm.rules},on:{"update:error":function($event){_vm.error = $event}}},[_c('div',{staticClass:"rating-input-slotted"},[_c('label',{class:{
        'v-label': true,
        'theme--dark': _vm.$vuetify.theme.dark,
        'theme--light': !_vm.$vuetify.theme.dark,
        'error--text': _vm.error,
      }},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-rating',{attrs:{"color":_vm.disabled ? 'grey' : 'primary',"small":"","background-color":"rgba(128,128,128,0.5)","value":_vm.value,"readonly":_vm.readonly,"dense":_vm.dense,"clearable":""},on:{"input":_vm.change}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }